import StoreInfoSFC from "./StoreInfo.vue";
export { type IStoreInfoProps } from "./props";
export const StoreInfo = StoreInfoSFC;
